'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _CompanyLogos = require('./CompanyLogos.css');

var _CompanyLogos2 = _interopRequireDefault(_CompanyLogos);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ReactTooltip from 'react-tooltip'
// import moment from 'moment'

var CompanyLogos = (_dec = (0, _reactCssModules2.default)(_CompanyLogos2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyLogos, _Component);

  function CompanyLogos(props) {
    (0, _classCallCheck3.default)(this, CompanyLogos);
    return (0, _possibleConstructorReturn3.default)(this, (CompanyLogos.__proto__ || (0, _getPrototypeOf2.default)(CompanyLogos)).call(this, props));
  }

  (0, _createClass3.default)(CompanyLogos, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // "investments in top fossil fuel companies"
      // go through holdings
      // see if they match against list of top 100
      // display logo if so
      // alt text: holding data
      // sort: holding assets desc
      // display 10 max

      // error check?
      if (!this.props.holdings || this.props.holdings.length === 0 || !this.props.fHoldingsMap || this.props.fHoldingsMap.length === 0) {
        return null;
      }

      var MAX_MATCHES = 6;
      var matchCount = 0;
      // const matches = []
      var topMatches = this.props.holdings.filter(function (x) {
        var isMatch = x.is_c2 === true || x.is_f15 === true;
        if (isMatch && matchCount < MAX_MATCHES) {
          matchCount += 1;
          return true;
        } else {
          return false;
        }
      });
      // console.log(topMatches)

      if (!topMatches || topMatches.length === 0) {
        return null;
      }

      // icon images
      var iconC2 = require('../../../static/images/icn-c2-active.svg');
      var iconF5 = require('../../../static/images/icn-f5-active.svg');

      var iconConfigs = [['is_c2', iconC2, 'Carbon Underground 200', 'Top 200 carbon reserves'], ['is_f15', iconF5, 'Macroclimate 50', 'Top 50 coal-fired power']];

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'company-logo-wrap' },
          topMatches.map(function (el, idx) {
            var hasLogo = false;
            var companyLogo = null;
            try {
              companyLogo = require('../../../static/images/cos/' + el.company_id + '.png');
              hasLogo = true;
            } catch (e) {
              // console.log('')
            }

            var fMoney = _format2.default.money(_this2.props.fHoldingsMap[el.id].market_value, true, 'USD', // shareClass.currency,
            false);

            return _react2.default.createElement(
              'div',
              {
                key: 'top-match-' + idx,
                styleName: 'item-wrap'
              },
              _react2.default.createElement(
                'div',
                {
                  styleName: 'company-logo-img-wrap',
                  title: el.security_name
                },
                hasLogo ? _react2.default.createElement('img', {
                  styleName: 'company-logo-img',
                  src: companyLogo,
                  alt: el.security_name
                }) : _react2.default.createElement(
                  'span',
                  null,
                  el.security_name
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'company-logo-details' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'company-logo-icons' },
                  /* mini-sector icons */
                  iconConfigs.map(function (sector, i) {
                    return el[sector[0]] ? _react2.default.createElement(
                      'span',
                      {
                        styleName: 'detail-icon-holding-wrp',
                        key: sector[0] + '_' + i
                      },
                      _react2.default.createElement('img', {
                        styleName: 'detail-icon-holding',
                        src: sector[1],
                        alt: sector[2],
                        title: sector[2]
                      }),
                      sector[3]
                    ) : null;
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'company-logo-assets' },
                  fMoney
                )
              )
            );
          })
        )
      );
    }
  }]);
  return CompanyLogos;
}(_react.Component), _class2.propTypes = {
  holdings: _react.PropTypes.array,
  fHoldingsMap: _react.PropTypes.object
}, _temp)) || _class);
exports.default = CompanyLogos;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyLogos/CompanyLogos.js
// module id = 1370
// module chunks = 0